import React from "react";

import { Card, SubHeader } from "clearsense-ui/components";

const CardsPanel = ({
  breadcrumbs,
  actionBlock,
  activePage = "",
  setActivePage = () => {},
  cards,
}) => (
  <div
    className="overflow-y-auto cs-ui-cards-panel"
    data-cy="cards-panel"
    data-testid="cards-panel"
  >
    <div className="overflow-x-hidden w-full">
      <SubHeader
        breadcrumbs={breadcrumbs}
        actionBlock={actionBlock}
        className="mx-4 mt-8"
      />
      <Card data-cy="explorer-card">
        {cards.map((card, index) => (
          <Card.Item
            key={index}
            count={card.count || 0}
            title={card.title || ""}
            onClick={() => setActivePage(card.title)}
            active={activePage === card.title}
            to={card.to}
          />
        ))}
      </Card>
    </div>
  </div>
);

export default CardsPanel;
